import { render, staticRenderFns } from "./LocationVerification.vue?vue&type=template&id=22d85977&scoped=true&"
import script from "./LocationVerification.vue?vue&type=script&lang=js&"
export * from "./LocationVerification.vue?vue&type=script&lang=js&"
import style0 from "./LocationVerification.vue?vue&type=style&index=0&id=22d85977&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d85977",
  null
  
)

export default component.exports